<template>
  <div :class="cssClass" @click="select">
    <svg
      v-if="isExistingChapter"
      class="main-icon"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 512 512"
      height="4em"
      width="4em"
      x="0px"
      y="0px"
      role="img"
    >
      <path :d="chapterIcons.get(chapter.slug_name)" />
    </svg>
    <div class="flex-auto d-flex-column-center text-center py-2 fs-4">
      {{ chapter.name }}
    </div>
    <div class="mt-2 mb-1">
      <AppIcon
        style="height: 1.5em"
        :class="isSelected ? 'text-success' : null"
        :icon="checkedIcon"
      />
    </div>
  </div>
</template>

<script>
import chapterIcons from '../mixins/chapterIcons'

export default {
  mixins: [chapterIcons],
  props: {
    chapter: {
      required: true,
      type: Object,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cssBorder: 'border border-1 rounded-3 border-primary',
      cssFrame:
        'text-white d-flex-column-center bg-secondary hover-pointer p-3 my-3',
    }
  },
  computed: {
    isExistingChapter() {
      if (!this.chapterIcons.has(this.chapter.slug_name)) {
        console.error(
          this.chapter.name,
          ': Milieu sans configuration existante'
        )
      }
      return this.chapterIcons.has(this.chapter.slug_name)
    },
    checkedIcon() {
      return this.isSelected ? 'checked' : 'unchecked'
    },
    cssClass() {
      let cssClass = `chapter-selector chapter-selector--${this.chapter.slug_name}`
      if (this.isSelected) {
        cssClass += ' chapter-selector--selected'
      }
      return (cssClass += ` ${this.cssBorder} ${this.cssFrame}`)
    },
  },
  methods: {
    select() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss">
.chapter-selector {
  width: clamp(170px, 20%, 30%);
  transition: font-weight 0.3s ease-in-out;
  &.chapter-selector--selected,
  &:hover .text-center {
    font-weight: 500;
  }
  path {
    transition: fill 0.6s ease-in-out;
  }
  .main-icon path {
    fill: var(--bs-gray-100);
  }
  &--milieu-agricole.chapter-selector--selected,
  &--milieu-agricole:hover {
    .main-icon path {
      fill: var(--gdep_color__ternary);
    }
  }
  &--milieu-forestier.chapter-selector--selected,
  &--milieu-forestier:hover {
    .main-icon path {
      fill: var(--gdep_color__secondary);
    }
  }
  &--milieu-habite.chapter-selector--selected,
  &--milieu-habite:hover {
    .main-icon path {
      fill: var(--gdep_color__primary-light);
    }
  }
}
</style>
